import {h, Fragment} from "preact"
export default function Checkbox({ value, count, selected, onChange, className }) {
    value = value.includes('["') ? JSON.parse(value).join(', ') : value
    let img = window.stones[`${value.toLowerCase().replaceAll(' ', '-')}`] || null

    return (
        <label className={`ns-checkbox ns-color-white ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span className="ns-checkmark">
                {img && <img src={img} alt={value} />}
            </span>
            {value}
            {count ? ` (${count})` : ''}
        </label>
    )
}